import { render, staticRenderFns } from "./Auctioneers.vue?vue&type=template&id=88b7dc6e&scoped=true&"
import script from "./Auctioneers.vue?vue&type=script&lang=ts&"
export * from "./Auctioneers.vue?vue&type=script&lang=ts&"
import style0 from "./Auctioneers.vue?vue&type=style&index=0&id=88b7dc6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b7dc6e",
  null
  
)

export default component.exports